import {
  apolloHooks,
  CustomContextVars,
  DocumentNode } from '@nxte-nl/apollo-hooks';

import { ProductsResponse } from '../../../types/apiCompoundProduct';

export type UseProductsQueryParams = {
  context?: CustomContextVars;
  onCompleted?: (response: ProductsResponse | null) => void;
  query: DocumentNode;
};
export const getProductsHooks = {
  useProductsQuery({
    query,
    onCompleted,
    context,
  }: UseProductsQueryParams) {
    const [executeRequest, { loading }] = apolloHooks.useLazyQuery<ProductsResponse>(
      query,
      {
        onCompleted,
        context,
      },
    );
    return {
      executeRequest,
      loading,
    };
  },
};
